import { useTranslation } from 'react-i18next';
import { NavigationItem } from '@cbridge-utils/navigation';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';

/**
 * Returns navigation items for the Risk Management section.
 * The whole section is gated by the markoutReport feature at the root navigation and route level.
 */
export const useRiskManagementNavigation = () => {
  const { t } = useTranslation();

  const items: NavigationItem[] = [
    {
      kind: 'page',
      segment: RouteSegments.RiskManagement.Markout,
      pattern: `${RouteSegments.RiskManagement.Markout}{/*path}`,
      title: t('text:navigation.riskManagement.markoutReport'),
    },
  ];

  return items;
};
